import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import MaterialSelectable from './MaterialSelectable'

const styles = theme => ({
	container: {
		display: 'flex',
		flexWrap: 'wrap',
	},
})

const country = {
	all: '',
	us: 'USA',
	canada: 'CAN',
	mexico: 'MEX',
	teritories: 'TER',
	military: 'MIL'
}

const states = [
	{ name: 'Alabama', 					short: 'Ala', 		id: 'AL', country: 'USA' },
	{ name: 'Alaska', 					short: 'Alaska',	id: 'AK', country: 'USA' },
	{ name: 'Arizona', 					short: 'Ariz.', 	id: 'AZ', country: 'USA' },
	{ name: 'Arkansas', 				short: 'Ark.', 		id: 'AR', country: 'USA' },
	{ name: 'California', 			short: 'Calif.', 	id: 'CA', country: 'USA' },
	{ name: 'Colorado', 				short: 'Colo.', 	id: 'CO', country: 'USA' },
	{ name: 'Connecticut', 			short: 'Conn.', 	id: 'CT', country: 'USA' },
	{ name: 'Delaware', 				short: 'Del.', 		id: 'DE', country: 'USA' },
	{ name: 'Dist.of Columbia',	short: 'D.C.', 		id: 'DC', country: 'USA' },
	{ name: 'Florida', 					short: 'Fla.', 		id: 'FL', country: 'USA' },
	{ name: 'Georgia', 					short: 'Ga.', 		id: 'GA', country: 'USA' },
	{ name: 'Hawaii', 					short: 'Hawaii', 	id: 'HI', country: 'USA' },
	{ name: 'Idaho', 						short: 'Idaho', 	id: 'ID', country: 'USA' },
	{ name: 'Illinois', 				short: 'Ill.', 		id: 'IL', country: 'USA' },
	{ name: 'Indiana', 					short: 'Ind.', 		id: 'IN', country: 'USA' },
	{ name: 'Iowa', 						short: 'Iowa', 		id: 'IA', country: 'USA' },
	{ name: 'Kansas', 					short: 'Kans.', 	id: 'KS', country: 'USA' },
	{ name: 'Kentucky', 				short: 'Ky.', 		id: 'KY', country: 'USA' },
	{ name: 'Louisiana', 				short: 'La.', 		id: 'LA', country: 'USA' },
	{ name: 'Maryland', 				short: 'MD', 			id: 'MD', country: 'USA' },
	{ name: 'Maine', 						short: 'Maine', 	id: 'ME', country: 'USA' },
	{ name: 'Massachusetts', 		short: 'Mass.', 	id: 'MA', country: 'USA' },
	{ name: 'Michigan', 				short: 'Mich.', 	id: 'MI', country: 'USA' },
	{ name: 'Minnesota', 				short: 'Minn.', 	id: 'MN', country: 'USA' },
	{ name: 'Mississippi', 			short: 'Miss.', 	id: 'MS', country: 'USA' },
	{ name: 'Missouri', 				short: 'Mo.', 		id: 'MO', country: 'USA' },
	{ name: 'Montana', 					short: 'Mont.', 	id: 'MT', country: 'USA' },
	{ name: 'Nebraska', 				short: 'Nebr.', 	id: 'NE', country: 'USA' },
	{ name: 'Nevada', 					short: 'Nev.', 		id: 'NV', country: 'USA' },
	{ name: 'New Hampshire', 		short: 'N.H.', 		id: 'NH', country: 'USA' },
	{ name: 'New Jersey', 			short: 'N.J.', 		id: 'NJ', country: 'USA' },
	{ name: 'New Mexico', 			short: 'N.M.', 		id: 'NM', country: 'USA' },
	{ name: 'New York', 				short: 'N.Y.', 		id: 'NY', country: 'USA' },
	{ name: 'North Carolina', 	short: 'N.C.', 		id: 'NC', country: 'USA' },
	{ name: 'North Dakota', 		short: 'N.D.', 		id: 'ND', country: 'USA' },
	{ name: 'Ohio', 						short: 'Ohio', 		id: 'OH', country: 'USA' },
	{ name: 'Oklahoma', 				short: 'Okla.', 	id: 'OK', country: 'USA' },
	{ name: 'Oregon', 					short: 'Ore.', 		id: 'OR', country: 'USA' },
	{ name: 'Pennsylvania', 		short: 'Pa.', 		id: 'PA', country: 'USA' },
	{ name: 'Rhode Island', 		short: 'R.I.', 		id: 'RI', country: 'USA' },
	{ name: 'South Carolina', 	short: 'S.C.', 		id: 'SC', country: 'USA' },
	{ name: 'South Dakota', 		short: 'S.D.', 		id: 'SD', country: 'USA' },
	{ name: 'Tennessee', 				short: 'Tenn.', 	id: 'TN', country: 'USA' },
	{ name: 'Texas', 						short: 'Tex.', 		id: 'TX', country: 'USA' },
	{ name: 'Utah', 						short: 'Utah', 		id: 'UT', country: 'USA' },
	{ name: 'Vermont', 					short: 'Vt.', 		id: 'VT', country: 'USA' },
	{ name: 'Virginia', 				short: 'Va.', 		id: 'VA', country: 'USA' },
	{ name: 'Washington', 			short: 'Wash.', 	id: 'WA', country: 'USA' },
	{ name: 'West Virginia', 		short: 'W.Va.', 	id: 'WV', country: 'USA' },
	{ name: 'Wisconsin', 				short: 'Wis.', 		id: 'WI', country: 'USA' },
	{ name: 'Wyoming', 					short: 'Wyo.', 		id: 'WY', country: 'USA' },

	{ name: 'American Samoa', 					short: 'AS', 	 id: 'AS', country: 'TER' },
	{ name: 'Guam', 										short: 'Guam', id: 'GU', country: 'TER' },
	{ name: 'Marshall Islands', 				short: 'MH', 	 id: 'MH', country: 'TER' },
	{ name: 'Micronesia', 							short: 'FM', 	 id: 'FM', country: 'TER' },
	{ name: 'Northern Marianas', 				short: 'MP', 	 id: 'MP', country: 'TER' },
	{ name: 'Palau', 										short: 'PW', 	 id: 'PW', country: 'TER' },
	{ name: 'Puerto Rico', 							short: 'P.R.', id: 'PR', country: 'TER' },
	{ name: 'Virgin Islands', 					short: 'V.I.', id: 'VI', country: 'TER' },

	{ name: 'Armed Forces Africa', 			short: 'AE', id: 'AE', country: 'MIL' },
	{ name: 'Armed Forces America', 		short: 'AA', id: 'AA', country: 'MIL' },
	{ name: 'Armed Forces Canada', 			short: 'AE', id: 'AE', country: 'MIL' },
	{ name: 'Armed Forces Europe', 			short: 'AE', id: 'AE', country: 'MIL' },
	{ name: 'Armed Forces Middle East', short: 'AE', id: 'AE', country: 'MIL' },
	{ name: 'Armed Forces Pacific', 		short: 'AP', id: 'AP', country: 'MIL' },

	{ name: 'Alberta', 									short: 'AB', id: 'AB', country: 'CAN' },
	{ name: 'British Columbia', 				short: 'BC', id: 'BC', country: 'CAN' },
	{ name: 'Manitoba', 								short: 'MB', id: 'MB', country: 'CAN' },
	{ name: 'New Brunswick', 						short: 'NB', id: 'NB', country: 'CAN' },
	{ name: 'Newfoundland', 						short: 'NL', id: 'NL', country: 'CAN' },
	{ name: 'Northwest Territories', 		short: 'NT', id: 'NT', country: 'CAN' },
	{ name: 'Nunavut', 									short: 'NU', id: 'NU', country: 'CAN' },
	{ name: 'Ontario', 									short: 'ON', id: 'ON', country: 'CAN' },
	{ name: 'Price Edward Island', 			short: 'PE', id: 'PE', country: 'CAN' },
	{ name: 'Quebec', 									short: 'QC', id: 'QC', country: 'CAN' },
	{ name: 'Saskatchewan', 						short: 'SK', id: 'SK', country: 'CAN' },
	{ name: 'Yukon', 										short: 'YT', id: 'YT', country: 'CAN' },
]

class StateSelection extends React.Component {
	render() {
		const { label, name, value, onChange, onBlur, disabled, country, required, error, errorMessage } = this.props

		let selectedStates = states.filter(loc =>  country === '' || loc.country === country).sort((a,b) => a.id.localeCompare(b.id))

		return (
			<MaterialSelectable
				name={name}
				label={label}
				value={value}
				options={selectedStates}
				disabled={disabled}
				required={required}
				error={error}
				errorMessage={errorMessage}
				onBlur={onBlur}
				onChange={onChange} />
		)
	}
}

StateSelection.propTypes = {
	classes: PropTypes.object.isRequired,
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	value: PropTypes.string.isRequired,
	extendedAddress: PropTypes.bool,
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	error: PropTypes.bool,
	errorMessage: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	onBlur: PropTypes.func,
	country: PropTypes.oneOf(Object.values(country)),
}

StateSelection.defaultProps = {
	label: 'State',
	value: '',
	extendedAddress: false,
	disabled: false,
	required: false,
	error: false,
	errorMessage: '',
	country: 'USA'
}

export default withStyles(styles)(StateSelection)


// WEBPACK FOOTER //
// ./src/components/StateSelection.js